export var HX_LIST = ["h1", "h2", "h3", "h4", "h5", "h6"];
var SIZES_LIST = ["xl", "lg", "md", "sm", "xs"];
var getVariantAndSizeClassNames = function (size, variant) {
    if (variant === "heading" && HX_LIST.includes(size)) {
        return "fr-".concat(size);
    }
    else if (variant === "display" && SIZES_LIST.includes(size)) {
        return "fr-".concat(variant, "--").concat(size);
    }
    else if (variant === "text" && SIZES_LIST.includes(size)) {
        if (size === "xl") {
            return "fr-text--lead";
        }
        else if (size === "md") {
            return "fr-".concat(variant);
        }
        else {
            return "fr-".concat(variant, "--").concat(size);
        }
    }
    else if (variant === "text-alt" && ["lg", "md", "sm", "xs"].includes(size)) {
        if (size !== "md") {
            return "fr-text--alt fr-text--".concat(size);
        }
        return "fr-text--alt";
    }
    else if (variant === "text-alt") {
        return "fr-text--alt";
    }
    return false;
};
export var calculateClassNames = function (_a) {
    var variant = _a.variant, size = _a.size, textAlign = _a.textAlign, noMarginBottom = _a.noMarginBottom, className = _a.className;
    var classNames = [];
    var variantAndSizeClassName = getVariantAndSizeClassNames(size, variant);
    if (variantAndSizeClassName) {
        classNames.push(variantAndSizeClassName);
    }
    if (textAlign) {
        classNames.push("ssg-text--align-".concat(textAlign));
    }
    if (noMarginBottom) {
        classNames.push("fr-mb-0");
    }
    if (className) {
        classNames.push(className);
    }
    if (classNames.length > 0) {
        return classNames.join(" ");
    }
    return "";
};
